import { useState, useEffect, useMemo } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axios from 'axios';
import Pagination from '../../component/Admin/Pagination';
import { FaPlusCircle, FaTrashAlt, FaSearch, FaSort, FaSortUp, FaSortDown, FaBuilding } from 'react-icons/fa';
import Loading from '../../component/Loading';
import Modal from 'react-modal';
import Swal from 'sweetalert2';
import { adminTable } from '../../component/Admin/adminTable';
import SortBar from '../../component/Admin/SortBar';
const Devisi = ({ data }) => {
    const header = {
        withCredentials: true,
    }
    const [listDevisi, setListDevisi] = useState([]);
    const [periode, setPeriode] = useState(localStorage.getItem('periode') || ''); // Mengambil periode dari localStorage

    const [meta, setMeta] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    
    // Search and Sort states
    const [searchTerm, setSearchTerm] = useState('');
    const [sortField, setSortField] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc'); // 'asc' or 'desc'

    useEffect(() => {
        getListDevisi();
        // eslint-disable-next-line
    }, [page, limit]);

    const getListDevisi = () => {
        // setLoadingSmall(true)
        axios.get(`api/devisi?page=${page}&limit=${limit}`, header)
            .then((response) => {
                setMeta(response.data.meta);
                setListDevisi(response.data.items);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };


    const selectPage = (value) => {
        setPage(value);
    };

    const nextPage = () => {
        if (page < meta.totalPages) {
            setPage(page + 1);
        }
    };

    const prevPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const limitPage = (event) => {
        setLimit(Number(event.target.value));
    };


    const closeModal = () => {
        setModalIsOpen(false);
    }


    const handleClick = (id, event) => {
        // Prevent opening modal when clicking delete button
        if (event && event.target.closest('span')) {
            return;
        }
        
        const data = listDevisi.filter(item => item.id_devisi === id);
        if (data.length > 0) {
            setModalData(data);
            setModalIsOpen(true);
        } else {
            setModalData(null);
            setModalIsOpen(false);
        }
    };

    const handleDelete = async (id, event) => {
        event.stopPropagation(); // Prevent row click
        
        const result = await Swal.fire({
            title: 'Apakah Anda yakin?',
            text: "Data devisi yang dihapus tidak dapat dikembalikan!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Ya, Hapus!',
            cancelButtonText: 'Batal'
        });

        if (!result.isConfirmed) {
            return;
        }
        
        setLoading(true);
        try {
            await axios.delete(`api/devisi/${id}`, header);
            await Swal.fire({
                icon: 'success',
                title: 'Berhasil!',
                text: 'Devisi berhasil dihapus',
                confirmButtonColor: '#3085d6',
                timer: 2000,
                showConfirmButton: true
            });
            getListDevisi(); // Refresh the list
        } catch (error) {
            console.error('Error deleting data:', error);
            Swal.fire({
                icon: 'error',
                title: 'Gagal!',
                text: error.response?.data?.message || 'Terjadi kesalahan saat menghapus data',
                confirmButtonColor: '#d33'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        const formData = new FormData(event.target);
        const data = Object.fromEntries(formData.entries());
        
        // Convert radius to number
        if (data.radius) {
            data.radius = Number(data.radius);
        }

        try {
            if (modalData && modalData.length > 0) {
                // Update existing data
                await axios.patch(`api/devisi/${modalData[0].id_devisi}`, data, header);
                await Swal.fire({
                    icon: 'success',
                    title: 'Berhasil!',
                    text: 'Data devisi berhasil diperbarui',
                    confirmButtonColor: '#3085d6',
                    timer: 2000,
                    showConfirmButton: true
                });
            } else {
                // Add new data
                await axios.post('api/devisi', data, header);
                await Swal.fire({
                    icon: 'success',
                    title: 'Berhasil!',
                    text: 'Devisi baru berhasil ditambahkan',
                    confirmButtonColor: '#3085d6',
                    timer: 2000,
                    showConfirmButton: true
                });
            }
            getListDevisi(); // Refresh the list
            closeModal();
            setModalData(null);
        } catch (error) {
            console.error('Error saving data:', error);
            Swal.fire({
                icon: 'error',
                title: 'Gagal!',
                text: error.response?.data?.message || error.response?.data?.error || 'Terjadi kesalahan saat menyimpan data',
                confirmButtonColor: '#d33'
            });
        } finally {
            setLoading(false);
        }
    };

    const openAddModal = () => {
        setModalData(null); // Reset modal data for new entry
        setModalIsOpen(true); // Open modal
    };

    // Handle sort
    const handleSort = (field) => {
        if (field == null) {
            setSortField(null);
            setSortDirection('asc');
            return;
        }
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    // Filtered and sorted data
    const filteredAndSortedDevisi = useMemo(() => {
        let filtered = listDevisi;

        // Apply search filter
        if (searchTerm) {
            filtered = filtered.filter(devisi => {
                const searchLower = searchTerm.toLowerCase();
                return (
                    devisi.id_devisi?.toString().includes(searchLower) ||
                    devisi.nama_divisi?.toLowerCase().includes(searchLower) ||
                    devisi.jaringan?.toLowerCase().includes(searchLower) ||
                    devisi.latitude?.toString().includes(searchLower) ||
                    devisi.longitude?.toString().includes(searchLower) ||
                    devisi.radius?.toString().includes(searchLower)
                );
            });
        }

        // Apply sort
        if (sortField) {
            filtered = [...filtered].sort((a, b) => {
                let aValue, bValue;

                switch (sortField) {
                    case 'id_devisi':
                        aValue = a.id_devisi || 0;
                        bValue = b.id_devisi || 0;
                        break;
                    case 'nama_divisi':
                        aValue = a.nama_divisi || '';
                        bValue = b.nama_divisi || '';
                        break;
                    case 'jaringan':
                        aValue = a.jaringan || '';
                        bValue = b.jaringan || '';
                        break;
                    case 'latitude':
                        aValue = parseFloat(a.latitude) || 0;
                        bValue = parseFloat(b.latitude) || 0;
                        break;
                    case 'longitude':
                        aValue = parseFloat(a.longitude) || 0;
                        bValue = parseFloat(b.longitude) || 0;
                        break;
                    case 'radius':
                        aValue = parseFloat(a.radius) || 0;
                        bValue = parseFloat(b.radius) || 0;
                        break;
                    default:
                        return 0;
                }

                if (typeof aValue === 'string' && typeof bValue === 'string') {
                    return sortDirection === 'asc'
                        ? aValue.localeCompare(bValue)
                        : bValue.localeCompare(aValue);
                }

                return sortDirection === 'asc'
                    ? (aValue > bValue ? 1 : -1)
                    : (aValue < bValue ? 1 : -1);
            });
        }

        return filtered;
    }, [listDevisi, searchTerm, sortField, sortDirection]);

    // Get sort icon
    const getSortIcon = (field) => {
        if (sortField !== field) {
            return <FaSort className="ml-1 text-gray-400" />;
        }
        return sortDirection === 'asc' 
            ? <FaSortUp className="ml-1 text-white" />
            : <FaSortDown className="ml-1 text-white" />;
    };
    return (
        <>
            {loading ? <Loading /> : null}

            <div className={adminTable.pageHeader}>
                <div>
                    <h1 className={adminTable.pageTitle}>
                        <FaBuilding className="text-[#1B3C33]" /> Data Devisi
                    </h1>
                    <p className={adminTable.pageSubtitle}>Unit organisasi pegawai. Lokasi absensi dikelola di menu Data Lokasi.</p>
                </div>
                <button className={adminTable.btnPrimary} onClick={openAddModal} type="button">
                    <FaPlusCircle /> Tambah Devisi
                </button>
            </div>

            <div className={adminTable.searchToolbar}>
                <div className={adminTable.searchWrap}>
                    <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                    <input
                        type="text"
                        placeholder="Cari nama devisi..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className={adminTable.searchInput}
                    />
                </div>
                <SortBar
                    options={[
                        { value: 'nama_divisi', label: 'Nama' },
                        { value: 'id_devisi', label: 'ID' },
                    ]}
                    sortField={sortField}
                    sortDirection={sortDirection}
                    onSort={handleSort}
                />
            </div>

            <div>
                <div className={adminTable.list}>
                    {filteredAndSortedDevisi.length > 0 ? (
                        filteredAndSortedDevisi.map((item, index) => (
                            <div
                                key={item.id_devisi}
                                className={adminTable.listItemClickable}
                                onClick={(e) => handleClick(item.id_devisi, e)}
                            >
                                <div className={adminTable.listTop}>
                                    <div className="min-w-0 flex-1">
                                        <div className={adminTable.listTitle}>{item.nama_divisi}</div>
                                        <div className={adminTable.listSub}>ID #{item.id_devisi}</div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={(e) => handleDelete(item.id_devisi, e)}
                                        className={`${adminTable.actionBtn} text-red-500 hover:bg-red-50`}
                                        title="Hapus Devisi"
                                    >
                                        <FaTrashAlt />
                                    </button>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className={adminTable.listEmpty}>
                            {searchTerm ? 'Data tidak ditemukan' : `Data Periode ${periode} tidak ditemukan`}
                        </div>
                    )}
                </div>

                <div className={`${adminTable.card} ${adminTable.desktopOnly}`}>
                    <div className={adminTable.scroll}>
                        <table className={adminTable.table}>
                            <thead className={adminTable.thead}>
                                <tr>
                                    <th className={adminTable.thCenter}>No.</th>
                                    <th className={adminTable.thSortable} onClick={() => handleSort('id_devisi')}>
                                        <div className="flex items-center">ID {getSortIcon('id_devisi')}</div>
                                    </th>
                                    <th className={adminTable.thSortable} onClick={() => handleSort('nama_divisi')}>
                                        <div className="flex items-center">Nama Devisi {getSortIcon('nama_divisi')}</div>
                                    </th>
                                    <th className={adminTable.thCenter}>Aksi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredAndSortedDevisi.length > 0 ? (
                                    filteredAndSortedDevisi.map((item, index) => (
                                        <tr key={item.id_devisi} onClick={(e) => handleClick(item.id_devisi, e)} className={adminTable.trClickable}>
                                            <td className={adminTable.tdCenter}>{index + 1}</td>
                                            <td className={adminTable.tdMuted}>{item.id_devisi}</td>
                                            <td className={`${adminTable.td} font-medium`}>{item.nama_divisi}</td>
                                            <td className={adminTable.tdCenter}>
                                                <button
                                                    type="button"
                                                    onClick={(e) => handleDelete(item.id_devisi, e)}
                                                    className={`${adminTable.actionBtn} text-red-500 hover:bg-red-50`}
                                                    title="Hapus Devisi"
                                                >
                                                    <FaTrashAlt />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={4} className={adminTable.empty}>
                                            {searchTerm ? 'Data tidak ditemukan' : `Data Periode ${periode} tidak ditemukan`}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="mt-3">
                    <Pagination
                        currentPage={page}
                        totalPages={meta.totalPages}
                        limitPage={limitPage}
                        selectPage={selectPage}
                        nextPage={nextPage}
                        prevPage={prevPage}
                    />
                </div>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Detail Modal"
                ariaHideApp={false}
                className="fixed w-screen inset-0 flex items-center justify-center h-screen p-4 bg-gray-500 bg-opacity-50"
                overlayClassName="fixed z-50 w-screen h-screen inset-0 bg-gray-800 bg-opacity-75"
            >
                {/* {modalData && modalData?.map(item => ( */}
                <div className=' shadow-lg rounded-lg bg-white md:w-4/5 w-full h-5/6 p-4'>
                    <div className=' text-center pt-2 text-xl font-semibold'>DETAIL DEVISI</div>
                    <div className="bg-white h-5/6 overflow-y-auto rounded-lg  max-w-full  m-3  ">
                        <div className=' md:w-4/5 w-full  mx-auto '>
                            <div className="grid  place-items-center">
                                <div className="w-full  bg-white  ">
                                    {/* <h1 className="text-xl font-semibold">Hello there ?, <span className="font-normal">please fill in your information to continue</span></h1> */}
                                    <form id='form-devisi' className="mt-6" onSubmit={handleSubmit}>
                                        <label htmlFor="nama_devisi" className="block mt-2 text-xs font-semibold text-gray-600 uppercase">Nama Devisi</label>
                                        <input id="nama_devisi" type="text" name="nama_devisi" placeholder="Nama unit/divisi" className="block w-full p-3 mt-2 text-gray-700 bg-gray-200 appearance-none focus:outline-none focus:bg-gray-300 focus:shadow-inner rounded" required defaultValue={modalData ? modalData[0].nama_divisi : ''} />
                                        <p className="text-xs text-gray-500 mt-2">Koordinat & jaringan absensi atur di menu Data Lokasi.</p>

                                        <button type="submit" className="w-full py-3 mt-6 font-medium tracking-widest text-white uppercase bg-[#1B3C33] shadow-lg focus:outline-none hover:bg-[#234A3F] hover:shadow-none rounded">
                                            Simpan
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                    <button onClick={closeModal} className="w-full py-2 px-4 bg-[#1B3C33] text-white rounded-lg">Close</button>
                </div>
                {/* ))} */}
            </Modal>
        </>
    );
};

export default Devisi;